// axiosInstance.js
import axios from 'axios';
import {
  getAuthToken,
  isUserLoggedIn,
  fetchGuestToken,
  setGuestToken,
} from './auth/authService';
import { toast } from 'react-toastify';
import { openSignInModal } from 'store/slices/authSlice';
import { store } from '../../store';

const axiosInstance = axios.create();

// Add token to every request
axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 guest recovery
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // Prevent infinite loops
//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       !isUserLoggedIn()
//     ) {
//       originalRequest._retry = true;

//       try {
//         const newGuestToken = await fetchGuestToken();
//         originalRequest.headers.Authorization = `Bearer ${newGuestToken}`;
//         return axiosInstance(originalRequest);
//       } catch (refreshError) {
//         console.error('Failed to refresh guest token', refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
  
      if (
        error.response?.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
  
        // Case 1: Guest user → try to refresh token and retry
        if (!isUserLoggedIn()) {
          try {
            const newToken = await fetchGuestToken();
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return axiosInstance(originalRequest); // Retry
          } catch (refreshErr) {
            console.error('Guest token refresh failed', refreshErr);
          }
        }
  
        // Case 2: Logged-in user → session expired
        else {
          //  toast.error('Session expired. Please sign in again.');
          store.dispatch(openSignInModal());
        }
      }
  
      return Promise.reject(error);
    }
  );

export default axiosInstance;
